module.exports = __webpack_public_path__ + "img/buy-icon6-en.8d5d23f.png";